import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetCompany,
  fetchPostCompany,
  fetchDeleteCompany,
  fetchPutCompany,
  cleanUpCompany,
  cleanUpMessageCompany,
} from 'state-managament/company.slice';

export default function useCompany(company) {
  const { error, success, isLoaded, data } = useSelector((state) => state.company);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpCompany());
  const cleanUpMessage = () => dispatch(cleanUpMessageCompany());
  const getCompany = (args) => dispatch(fetchGetCompany(args));
  const postCompany = (args) => dispatch(fetchPostCompany(args));
  const deleteCompany = (args) => dispatch(fetchDeleteCompany(args));
  const putCompany = (args) => dispatch(fetchPutCompany(args));

  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getCompany,
    postCompany,
    deleteCompany,
    putCompany,
  };
}
